<template>
  <v-card class="card-wrap">
    <v-card-title><slot name="title"></slot></v-card-title>
    <div class="box">
      <v-data-table :headers="headers" :items="rows" item-key="text" class="elevation-1" dense hide-default-footer hide-default-header>
        <template #item.count="{ item }">
          {{ item.count | comma }}
        </template>
        <template #item.actions="{ item }">
          <v-icon small @click="openDetail(item)">
            mdi-card-search
          </v-icon>
        </template>
      </v-data-table>
    </div>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    headers: [
      { text: 'text', sortable: false, value: 'text', width: '70%', align: 'end' },
      { text: 'count', sortable: false, value: 'count', width: '20%', align: 'end' },
      { text: '', sortable: false, value: 'actions', width: '10%', align: 'center' },
    ],
  }),
  props: {
    params: {
      type: Object,
      required: true,
    },
    rows: {
      type: Array,
      required: true,
    },
  },
  methods: {
    openDetail(item) {
      if (item.count == 0) return;
      let url, params, options;
      params = {
        ymd: this.params.svrYmdhms,
        sstm: this.params.sstmId,
        mand: this.params.mandt,
        stim: this.params.srchBgnYmd,
        etim: this.params.srchEndYmd,
        key: item.rowKey,
      };
      url = '/views/extra/auth/rtrck-summary-detail';
      options = 'width=1200, height=846';
      window.open(`${url}?${new URLSearchParams(params).toString()}`, '_blank', options);
    },
  },
};
</script>

<style></style>
